import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  toggle() {
    const visible = this.inputTarget.type === "text"
    this.inputTarget.type = visible ? "password" : "text"
    this.iconTarget.setAttribute("aria-label", visible ? this.iconTarget.dataset.passwordToggleShowLabel : this.iconTarget.dataset.passwordToggleHideLabel)
    this.iconTarget.innerHTML = visible ? this.eyeIcon() : this.eyeSlashIcon()
  }

  eyeIcon() {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="h-5 w-5"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6-9.75-6-9.75-6Z"/><circle cx="12" cy="12" r="2.5"/></svg>'
  }

  eyeSlashIcon() {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="h-5 w-5"><path stroke-linecap="round" stroke-linejoin="round" d="m3 3 18 18M10.58 10.58a2 2 0 0 0 2.83 2.83M9.88 5.09A10.7 10.7 0 0 1 12 4.87c6 0 9.75 7.13 9.75 7.13a17.4 17.4 0 0 1-3.1 3.84M6.61 6.61C3.91 8.45 2.25 12 2.25 12S6 19.13 12 19.13a10.7 10.7 0 0 0 2.12-.22"/></svg>'
  }
}
